$(function() {
  const bodyDescriptor = document.getElementsByTagName('body')[0],
    menu = document.getElementsByClassName('menu')[0],
    menuLists = menu.getElementsByClassName('menu__list'),
    mainMenuList = menuLists[0],
    headerDescriptor = document.getElementsByClassName('header__content')[0],
    footer = document.getElementsByClassName('menu__footer')[0],
    headerStateClasses = {
      shown: 'header__content_shown',
    },

    headerHamburgerStateClasses = {
      base: 'header__hamburger',
    },

    icons = {
      open: 'icon-hamburger',
      close: 'icon-close',
      back: 'icon-back',
    },

    menuStateClasses = {
      shown: 'menu_shown',
    },

    mainMenuListStateClasses = {
      base: 'menu__list',
      shown: 'menu__list_shown',
    },

    footerStateClasses = {
      hidden: 'menu__footer_hidden',
    },

    overflowYHiddenClass = 'overflow-y-hidden',

    menuItemStateClasses = {
      base: 'menu__item',
      active: 'menu__item_active',
    },

    menuLinkStateClasses = {
      active: 'menu__link_active',
    },

    linkDataAttribute = 'data-inner-toggle';

  function checkWindow() {
    return $(document).width() >= 1220;
  }

  $(document).on('click', 'a[' + linkDataAttribute + ']', function(event) {
    event.preventDefault();

    if(checkWindow()){
      return;
    }

    const li = $(this).parent();
    $(this).hide();
    li.parent()
      .children('li')
      .not(li)
      .hide();

    li.addClass(menuItemStateClasses.active);

    li.children('ul')
      .addClass(mainMenuListStateClasses.base + ' ' +
        mainMenuListStateClasses.shown)
      .show();

    $('.' + headerHamburgerStateClasses.base)
      .removeClass(icons.close)
      .addClass(icons.back);
  });

  $(document).on('click', '.' + icons.close, function() {
    $('.' + headerHamburgerStateClasses.base)
      .removeClass(icons.close)
      .addClass(icons.open);

    $('.' + menuItemStateClasses.base).removeAttr('style');
    $('[' + linkDataAttribute + ']').each(function() {
      $(this).parent().children('ul').removeAttr('style');
    });

    mainMenuList.classList.remove(mainMenuListStateClasses.shown);
    footer.classList.add(footerStateClasses.hidden);
    bodyDescriptor.classList.remove(overflowYHiddenClass);
    menu.classList.remove(menuStateClasses.shown);
    headerDescriptor.classList.remove(headerStateClasses.shown);
  });

  $(document).on('click', '.' + icons.back, function() {
    const li = $('.' + menuItemStateClasses.active).last();
    li.removeClass(menuItemStateClasses.active);

    li.children('ul')
      .removeClass(mainMenuListStateClasses.base + ' ' +
        mainMenuListStateClasses.shown)
      .hide();
    li.children('a').show();

    li.parent().children('li').show();
    li.parent().addClass(mainMenuListStateClasses.base + ' ' +
      mainMenuListStateClasses.shown).show();

    const parent = li.parents('ul').first();

    if (parent.parent().is('nav')) {
      $('.' + headerHamburgerStateClasses.base)
        .removeClass(icons.back)
        .addClass(icons.close);
    }
  });

  $(document).on('click', '.' + icons.open, function() {
    $('[' + linkDataAttribute + ']').each(function() {
      $(this).parent().children('ul').hide();
    });

    $('.' + headerHamburgerStateClasses.base)
      .removeClass(icons.open)
      .addClass(icons.close);

    mainMenuList.classList.add(mainMenuListStateClasses.shown);
    footer.classList.remove(footerStateClasses.hidden);
    bodyDescriptor.classList.add(overflowYHiddenClass);
    menu.classList.add(menuStateClasses.shown);
    headerDescriptor.classList.add(headerStateClasses.shown);
  });

  $('.' + menuItemStateClasses.base).hover(function() {
    $('a').removeClass(menuLinkStateClasses.active);
    $(this).children('a').addClass(menuLinkStateClasses.active);
  }).mouseleave(function() {
    $('a').removeClass(menuLinkStateClasses.active);
  });
});
